export {
  deleteFx as deleteMerchantFx,
  Gate as DeleteMerchantGate,
  setFields as setDeleteMerchantFields,
  $fields as $deleteMerchantFields,
  $deleteStatus as $deleteMerchantStatus,
} from './model'
export * from './ui'
